import { render, staticRenderFns } from "./UtilEmpty.vue?vue&type=template&id=e0450c30&scoped=true"
import script from "./UtilEmpty.vue?vue&type=script&lang=js"
export * from "./UtilEmpty.vue?vue&type=script&lang=js"
import style0 from "./UtilEmpty.vue?vue&type=style&index=0&id=e0450c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0450c30",
  null
  
)

export default component.exports